import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CimSubstationService, SubstationTemplateDto, SubstationTemplateService } from 'shared-lib';

@Component({
  selector: 'app-map-substation-schema-diagram',
  templateUrl: './map-substation-schema-diagram.component.html',
  styleUrls: ['./map-substation-schema-diagram.component.scss'],
  standalone: false,
})
export class MapSubstationSchemaDiagramComponent implements OnInit {
  loading = true;
  noPublishedSchemas = false;

  templateOptions: SubstationTemplateDto[] = [];
  substationOptions: any[] = [];
  private allSubstationOptions: any[] = [];
  selectedTemplate: SubstationTemplateDto | null = null;
  selectedSubstation: any | null = null;
  selectedSubstationId: number | null = null;

  constructor(
    private cimSubstationService: CimSubstationService,
    private substationTemplateService: SubstationTemplateService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    forkJoin({
      templates: this.substationTemplateService.getAllForSelect(),
      defaultSubstation: this.cimSubstationService.getFirstSubstationWithPublishedSchema(),
    }).subscribe({
      next: ({ templates, defaultSubstation }) => {
        this.templateOptions = templates?.body?.data || [];

        this.loading = false;
        const substation = defaultSubstation?.body?.data;
        if (!substation) {
          this.noPublishedSchemas = true;
          return;
        }

        this.selectedTemplate = this.templateOptions.find((t) => t.id === substation.substationTemplateId) ?? null;
        this.selectSubstation(substation);
        this.loadSubstationsForTemplate(substation.substationTemplateId);
      },
      error: () => {
        this.loading = false;
        this.toastr.error('Error occurred while loading the schema diagram list');
      },
    });
  }

  onTemplateSelected(template: SubstationTemplateDto): void {
    this.selectedTemplate = template;
    this.selectedSubstation = null;
    this.substationOptions = [];
    this.allSubstationOptions = [];
    this.loadSubstationsForTemplate(template.id!);
  }

  onSubstationSelected(substation: any): void {
    this.selectSubstation(substation);
  }

  onSubstationFilterChange(searchTerm: string): void {
    const term = (searchTerm ?? '').toLowerCase();
    this.substationOptions = this.allSubstationOptions.filter((x) => x.name?.toLowerCase().includes(term));
  }

  private selectSubstation(substation: any): void {
    this.selectedSubstation = substation;
    this.selectedSubstationId = substation?.id ?? null;
    if (substation) {
      this.noPublishedSchemas = false;
    }
  }

  private loadSubstationsForTemplate(templateId: number): void {
    this.cimSubstationService.getAllForSelect({ templateId, searchTerm: '', onlyWithPublishedSchema: true }).subscribe({
      next: (response: any) => {
        this.allSubstationOptions = response?.body?.data || [];
        this.substationOptions = this.allSubstationOptions;
      },
      error: () => this.toastr.error('Error occurred while fetching substations'),
    });
  }
}
